import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';

const TreasureWreck = {
  id: '75',
  name: "Treasure Wreck",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Treasure_Wreck',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Treasure_Wreck',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevelAndEra(
        (level, era) => {
          const eraData = {
            stoneAge: { init: 7000, step: 1500},
            bronzeAge: { init: 12000, step: 2000},
            minoanEra: { init: 13500, step: 2500},
            classicGreece: { init: 15000, step: 3000},
            earlyRome: { init: 16500, step: 3500},
            romanEmpire: { init: 18000, step: 4000},
            byzantineEra: { init: 20000, step: 4700},
            ageOfTheFranks: { init: 22000, step: 5500},
            feudalAge: { init: 24000, step: 6200},
            iberianEra: { init: 26000, step: 7000},
            kingdomOfSicily: { init: 27800, step: 7800},
            highMiddleAges: { init: 31000, step: 8500},
            earlyGothicEra: { init: 35000, step: 9200},
            lateGothicEra: { init: 0, step: 0},
          };
          if (eraData[era] === undefined) {
            console.error(`Unknown era ${era} for building effect on ${TreasureWreck.name}`);
            return 0;
          }

          return eraData[era].init + (level - 1) * eraData[era].step;
        }
      ).withOutput(ProductionOutputType.GOLD),
    ),
    new PassiveAura(
      PassiveAuraType.TREASURE_HUNT_ATTEMPTS_CAP,
      EffectAmount.asCallbackWithLevel(
        (level) => {
          if (level < 10) {
            return 0;
          }
          if (level < 30) {
            return 1;
          }
          if (level < 50) {
            return 2;
          }
          return 3;
        }
      ),
    ),
    new PassiveAura(
      PassiveAuraType.TREASURE_HUNT_ATTEMPT_GENERATION_TIME_BONUS,
      EffectAmount.asCallbackWithLevel(
        (level) => {
          if (level < 5) {
            return 2;
          }
          if (level < 15) {
            return 5;
          }
          if (level < 20) {
            return 10;
          }
          if (level < 25) {
            return 15;
          }
          if (level < 35) {
            return 20;
          }
          if (level < 40) {
            return 25;
          }
          if (level < 45) {
            return 30;
          }
          if (level < 55) {
            return 35;
          }
          if (level < 60) {
            return 40;
          }
          return 45;
        }
      ),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.LIGHT_INFANTRY_DAMAGE_MOD,
      EffectAmount.asCallbackWithLevel(
        (level) => {
          if (level === 1) {
            return 0;
          }
          if (level <= 5) {
            return 2;
          }
          if (level <= 8) {
            return 2.5;
          }
          if (level <= 11) {
            return 3;
          }
          if (level <= 15) {
            return 3.5;
          }
          if (level <= 18) {
            return 4;
          }
          if (level <= 21) {
            return 4.5;
          }
          if (level <= 25) {
            return 5;
          }
          if (level <= 28) {
            return 5.5;
          }
          if (level <= 31) {
            return 6;
          }
          if (level <= 35) {
            return 6.5;
          }
          if (level <= 38) {
            return 7;
          }
          if (level <= 41) {
            return 7.5;
          }
          if (level <= 45) {
            return 8;
          }
          if (level <= 48) {
            return 8.5;
          }
          if (level <= 51) {
            return 9;
          }
          if (level <= 55) {
            return 9.5;
          }
          if (level <= 58) {
            return 10;
          }
          return 10.5;
        }
      ),
      '%',
    ),
  ]),
};

export default TreasureWreck;
